<template>
  <div id="confirmation-form">
    <Modal autoShow="false" />
    <div v-if="this.$store.state.error">
      <b-alert show variant="danger">{{ this.$store.state.errorMsg }}</b-alert>
    </div>
    <b-form @submit.stop.prevent="onSubmit">
      <b-form-group id="example-input-group-1" label="Confirmation Token:" label-for="example-input-1">
        <b-form-input
          id="token-input"
          name="token"
          v-model="$v.form.token.$model"
          :state="$v.form.token.$dirty ? !$v.form.token.$error : null"
          v-on:update="onUpdate"
          aria-describedby="input-1-live-feedback"
          placeholder="XXXXX"
        ></b-form-input>

        <b-form-invalid-feedback id="input-1-live-feedback">
          This is a required field, numeric only and must be 6 characters.
        </b-form-invalid-feedback>
      </b-form-group>
      <br />
      <b-button
        type="submit"
        variant="primary"
        class="btn-lg btn-block"
        :disabled="$v.form.$invalid"
      >
        Submit
      </b-button>
    </b-form>
  </div>
</template>
<script>
import { required, minLength, maxLength, numeric } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import Modal from '@/components/Modal.vue'

export default {
  components: { Modal },
  mixins: [validationMixin],
  data () {
    return {
      form: {
        token: null
      }
    }
  },
  validations: {
    form: {
      token: {
        required,
        numeric,
        minLength: minLength(6),
        maxLength: maxLength(6)
      }
    }
  },
  created: function () {
    // console.log(this.$store.state) // Just testing state, delete
  },
  methods: {
    onUpdate () {
      this.$store.commit('setError', false)
    },
    onSubmit () {
      this.$v.form.$touch()

      if (this.$v.form.$anyError) {
        return false
      }

      this.$store.dispatch('verifyTokenAction', {
        formData: this.$v.form.$model,
        userId: this.$store.state.pii.userId
      })
    }
  }
}
</script>
<style lang="less">
  #confirmation-form {
    .form-group {
      // min-height: 70px;
    }
    text-align: center;
    label {
      text-align: left;
    }
    #token-input {
      // width: 300px;
    }
  }
</style>
